(function () {
  'use strict';

  /*
   * =========================================================
   * CONFIDENTIAL COUTURE
   * PRODUCT CARD SECOND IMAGE HOVER
   * =========================================================
   *
   * Required image attributes:
   *
   * data-second-image="SECOND_IMAGE_URL"
   *
   * Optional:
   * data-original-src="ORIGINAL_IMAGE_URL"
   *
   * =========================================================
   */

  var CARD_SELECTOR = '.paira-product';

  var IMAGE_SELECTOR =
    'img[data-second-image]:not([data-cc-hover-initialized])';


  /*
   * ---------------------------------------------------------
   * PRELOAD SECOND IMAGE ONLY WHEN USER HOVERS
   * ---------------------------------------------------------
   */

  function preloadImage(url, callback) {

    if (!url) {
      if (callback) callback();
      return;
    }

    var preload = new Image();

    preload.onload = function () {
      if (callback) callback(true);
    };

    preload.onerror = function () {
      if (callback) callback(false);
    };

    preload.src = url;
  }


  /*
   * ---------------------------------------------------------
   * INITIALIZE ONE PRODUCT IMAGE
   * ---------------------------------------------------------
   */

  function initializeProductImage(img) {

    if (!img) return;

    if (
      img.getAttribute('data-cc-hover-initialized') === 'true'
    ) {
      return;
    }

    var secondImageUrl =
      img.getAttribute('data-second-image');

    if (!secondImageUrl) {
      return;
    }


    /*
     * Find product card.
     */

    var card =
      img.closest(CARD_SELECTOR) ||
      img.closest('.product') ||
      img.closest('.pro-im') ||
      img.closest('.product-image-link');

    if (!card) {
      return;
    }


    /*
     * Mark initialized.
     */

    img.setAttribute(
      'data-cc-hover-initialized',
      'true'
    );


    /*
     * -------------------------------------------------------
     * SAVE ORIGINAL IMAGE STATE
     * -------------------------------------------------------
     */

    var originalSrc =
      img.getAttribute('src') || '';

    var originalSrcset =
      img.getAttribute('srcset') || '';

    var originalSizes =
      img.getAttribute('sizes') || '';

    var originalClass =
      img.className;


    /*
     * Shopify/lazy-load themes sometimes use:
     *
     * data-src
     * data-srcset
     *
     * Save those too.
     */

    var originalDataSrc =
      img.getAttribute('data-src') || '';

    var originalDataSrcset =
      img.getAttribute('data-srcset') || '';


    /*
     * State
     */

    var showingSecond = false;

    var loadingSecond = false;

    var secondImageReady = false;


    /*
     * -------------------------------------------------------
     * LOAD SECOND IMAGE
     * -------------------------------------------------------
     */

    function loadSecondImage() {

      if (secondImageReady) {
        return;
      }

      if (loadingSecond) {
        return;
      }

      loadingSecond = true;

      preloadImage(
        secondImageUrl,
        function (success) {

          loadingSecond = false;

          if (success) {
            secondImageReady = true;
          }

        }
      );
    }


    /*
     * -------------------------------------------------------
     * SHOW SECOND IMAGE
     * -------------------------------------------------------
     */

    function showSecondImage() {

      if (showingSecond) {
        return;
      }

      /*
       * Save the current image state.
       *
       * This is important because lazyload may have
       * changed the original image after page load.
       */

      img.setAttribute(
        'data-cc-current-src',
        img.getAttribute('src') || originalSrc
      );

      img.setAttribute(
        'data-cc-current-srcset',
        img.getAttribute('srcset') || originalSrcset
      );

      img.setAttribute(
        'data-cc-current-sizes',
        img.getAttribute('sizes') || originalSizes
      );


      /*
       * Switch to second image.
       */

      img.setAttribute(
        'src',
        secondImageUrl
      );


      /*
       * Remove responsive attributes while the second
       * image is active so browser does not choose the
       * first image from its srcset.
       */

      img.removeAttribute('srcset');

      img.removeAttribute('sizes');


      /*
       * Mark state.
       */

      showingSecond = true;

      img.setAttribute(
        'data-cc-showing-second',
        'true'
      );
    }


    /*
     * -------------------------------------------------------
     * RESTORE FIRST IMAGE
     * -------------------------------------------------------
     */

    function showOriginalImage() {

      if (!showingSecond) {
        return;
      }


      var restoreSrc =
        img.getAttribute('data-cc-current-src') ||
        originalSrc;


      var restoreSrcset =
        img.getAttribute('data-cc-current-srcset') ||
        originalSrcset;


      var restoreSizes =
        img.getAttribute('data-cc-current-sizes') ||
        originalSizes;


      /*
       * Restore image.
       */

      if (restoreSrc) {

        img.setAttribute(
          'src',
          restoreSrc
        );

      }


      /*
       * Restore srcset.
       */

      if (restoreSrcset) {

        img.setAttribute(
          'srcset',
          restoreSrcset
        );

      } else {

        img.removeAttribute('srcset');

      }


      /*
       * Restore sizes.
       */

      if (restoreSizes) {

        img.setAttribute(
          'sizes',
          restoreSizes
        );

      } else {

        img.removeAttribute('sizes');

      }


      /*
       * Restore lazy-load attributes if they existed.
       */

      if (originalDataSrc) {

        img.setAttribute(
          'data-src',
          originalDataSrc
        );

      }

      if (originalDataSrcset) {

        img.setAttribute(
          'data-srcset',
          originalDataSrcset
        );

      }


      /*
       * Reset state.
       */

      showingSecond = false;

      img.setAttribute(
        'data-cc-showing-second',
        'false'
      );
    }


    /*
     * -------------------------------------------------------
     * DESKTOP HOVER
     * -------------------------------------------------------
     */

    card.addEventListener(
      'mouseenter',
      function () {

        /*
         * Start downloading second image only when
         * customer actually interacts with the card.
         */

        loadSecondImage();

        showSecondImage();

      },
      false
    );


    card.addEventListener(
      'mouseleave',
      function () {

        showOriginalImage();

      },
      false
    );


    /*
     * -------------------------------------------------------
     * TOUCH / MOBILE
     * -------------------------------------------------------
     */

    var touchTimer = null;


    card.addEventListener(
      'touchstart',
      function () {

        loadSecondImage();

        showSecondImage();


        /*
         * Automatically return to the first image.
         */

        if (touchTimer) {

          clearTimeout(
            touchTimer
          );

        }


        touchTimer = setTimeout(
          function () {

            showOriginalImage();

          },
          1500
        );

      },
      {
        passive: true
      }
    );


    /*
     * -------------------------------------------------------
     * CLEANUP WHEN CARD IS REMOVED
     * -------------------------------------------------------
     */

    card.addEventListener(
      'mouseleave',
      function () {

        if (touchTimer) {

          clearTimeout(
            touchTimer
          );

          touchTimer = null;

        }

      },
      false
    );
  }


  /*
   * ---------------------------------------------------------
   * INITIALIZE ALL PRODUCT CARDS
   * ---------------------------------------------------------
   */

  function initializeAllProductImages(root) {

    root = root || document;


    var images =
      root.querySelectorAll(
        IMAGE_SELECTOR
      );


    if (!images.length) {
      return;
    }


    Array.prototype.forEach.call(
      images,
      function (img) {

        initializeProductImage(img);

      }
    );
  }


  /*
   * ---------------------------------------------------------
   * INITIAL PAGE LOAD
   * ---------------------------------------------------------
   */

  function start() {

    initializeAllProductImages(
      document
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }


  /*
   * ---------------------------------------------------------
   * SHOPIFY SECTION RELOAD
   * ---------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initializeAllProductImages(
        event.target || document
      );

    }
  );


  /*
   * ---------------------------------------------------------
   * SHOPIFY THEME EDITOR
   * ---------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initializeAllProductImages(
        event.target || document
      );

    }
  );


  /*
   * ---------------------------------------------------------
   * YOUR THEME AJAX RELOAD
   * ---------------------------------------------------------
   */

  document.addEventListener(
    'shopwise:ajax:loaded',
    function () {

      initializeAllProductImages(
        document
      );

    }
  );


})();


(function () {

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function closeMenu(item) {

    item.classList.remove('cc-mobile-dropdown-open');

    var submenu = item.querySelector(':scope > .dropdown-menu');

    if (submenu) {
      submenu.style.setProperty('display', 'none', 'important');
    }

    var link = item.querySelector(':scope > a');

    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }
  }


  function openMenu(item) {

    item.classList.add('cc-mobile-dropdown-open');

    var submenu = item.querySelector(':scope > .dropdown-menu');

    if (submenu) {
      submenu.style.setProperty('display', 'block', 'important');
    }

    var link = item.querySelector(':scope > a');

    if (link) {
      link.setAttribute('aria-expanded', 'true');
    }
  }


  function closeOtherMenus(currentItem) {

    document
      .querySelectorAll(
        '.nav.navbar-nav > li.dropdown.paira-dropdown.cc-mobile-dropdown-open'
      )
      .forEach(function (item) {

        if (item !== currentItem) {
          closeMenu(item);
        }

      });

  }


  document.addEventListener('click', function (event) {

    if (!isMobile()) return;

    var link = event.target.closest(
      '.nav.navbar-nav > li.dropdown.paira-dropdown > a'
    );

    if (!link) return;

    var item = link.parentElement;

    if (!item) return;

    var rect = link.getBoundingClientRect();

    /*
      RIGHT-SIDE TOUCH ZONE

      The rightmost 110px of the whole menu row
      acts as the dropdown trigger.
    */

    var touchZoneStart = rect.right - 110;

    if (event.clientX < touchZoneStart) {
      return;
    }

    /*
      Prevent the normal theme link/dropdown handler.
    */

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();


    /*
      CLICK AGAIN = CLOSE
    */

    var alreadyOpen = item.classList.contains(
      'cc-mobile-dropdown-open'
    );


    if (alreadyOpen) {

      closeMenu(item);

    } else {

      closeOtherMenus(item);
      openMenu(item);

    }

  }, true);


  /* ---------------------------------------------------------
     RESET CUSTOM STATE WHEN LEAVING MOBILE
  --------------------------------------------------------- */

  window.addEventListener('resize', function () {

    if (window.innerWidth > 767) {

      document
        .querySelectorAll(
          '.nav.navbar-nav > li.dropdown.paira-dropdown.cc-mobile-dropdown-open'
        )
        .forEach(function (item) {

          closeMenu(item);

        });

    }

  });

})();
